/**
 * inputSwitchDirective
 *
 * @author Dec Norton <decnorton@gmail.com>
 */

export function inputSwitchDirective() {
    return {
        restrict: 'E',
        transclude: {
            appHint: '?appHint',
        },
        // language=HTML
        template: `
            <label class="form-field-label" ng-if="label && !hideMessage">
                {{ label }}
            </label>

            <md-switch class="md-primary"
                       ng-model="value"
                       ng-disabled="disabled"
                       aria-label="{{ label }}">
                <span ng-if="hideMessage">
                    {{ label }}
                </span>

                <span ng-if="!hideMessage">
                    {{ value ? (messageTrue || 'Yes') : (messageFalse || 'No') }}
                </span>
            </md-switch>

            <div class="hint"
                 ng-show="!isHintEmpty && !form[name].$invalid"
                 ng-transclude="appHint">
                {{ hint }}
            </div>

            <div ng-if="form[name]" ng-messages="form[name].$error">
                <div ng-message="required">Required</div>
                <div ng-message="custom">{{ form[name].customError }}</div>
                <div ng-repeat="(key, message) in errorMessages" ng-message="{{ key }}">
                    {{ message }}
                </div>
            </div>
        `,
        scope: {
            disabled: '=ngDisabled',
            errorMessages: '=errorMessages',
            form: '=form',
            hint: '@?hint',
            label: '@label',
            hideMessage: '=?hideMessage',
            onChange: '&?change',
            name: '@name',
            messageTrue: '@?messageTrue',
            messageFalse: '@?messageFalse',
            required: '=?required',
            tabindex: '@?appTabindex',
            value: '=value',
        },
        link: function(scope, element, attrs) {
            element.addClass('app-form-field');

            const $hint = element[0].querySelectorAll('.hint')[0];

            scope.isHintEmpty = false;

            scope.onValueChanged = onValueChanged;

            // If it's undefined on the scope, it may mean that the attribute is there but
            // without content. If the attribute isn't undefined then we know it's been added.
            if (scope.required === undefined && attrs.required !== undefined) {
                scope.required = true;
            }

            scope.$watch('value', value => {
                // If it's null, make it false.
                if (value === null) {
                    scope.value = false;
                }
            });

            scope.$watch(
                () => $hint.innerHTML,
                value => {
                    scope.isHintEmpty = value.trim().length <= 0;
                },
            );

            function onValueChanged() {
                if (angular.isFunction(scope.onChange)) {
                    scope.onChange();
                }

                if (!scope.form || !scope.name) {
                    return;
                }

                if (scope.value && scope.form && scope.form[scope.name]) {
                    scope.form[scope.name].$setValidity('custom', true);
                    scope.form[scope.name].customError = null;
                }
            }
        },
    };
}
